import axios, { resHandle } from "@/plugins/axios";

/**
 * @description 舌诊教材内容
 * @param vCom Vue组件
 */
const GetShezhenjiaocai$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/edu/szjc", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch((err: any) => {
            reject(err);
        });
    });
};



/**
 * @description 典型舌图内容
 * @param vCom Vue组件
 */
const GetDianxingshetu$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/edu/stnr", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch((err: any) => {
            reject(err);
        });
    });
};


/**
 * @description 舌诊实训：题型列表
 * @param vCom Vue组件
 */
const GetShixunFenlei$ = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/edu/szsx/cates").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 舌诊实训：题目列表
 * @param vCom Vue组件
 */
const GetShixunTimu$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/edu/szsx/questions", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 舌诊实训：学生答案记录
 * @param vCom Vue组件
 */
const SaveShixinQuestionResult$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/edu/szsx/lianxi", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 舌诊实训：智能学习报告
 * @param vCom Vue组件
 */
const GetShixunReport$ = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/edu/szsx/report").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 舌诊实训：智能学习报告用户信息
 * @param vCom Vue组件
 */
const GetUserInfo$ = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/edu/user/info").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 模拟考试：题目列表
 * @param vCom Vue组件
 */
const GetMoniTimu$ = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/edu/moni/questions").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 模拟考试：交卷
 * @param vCom Vue组件
 */
const PostMoniSave$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/edu/moni/questions", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 模拟测试：查看答题情况
 * @param vCom Vue组件
 */
const CheckMoniResult$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/edu/moni/answers", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 舌诊考试：考试列表页
 * @param vCom Vue组件
 */
const GetExams$ = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/edu/szks/exams").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};


/**
 * @description 舌诊考试：保存答案
 * @param vCom Vue组件
 */
const FinishExam$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/edu/szks/reply", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 舌诊考试：考试详情页 学生信息
 * @param vCom Vue组件
 */
const GetStudentInfo$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/edu/szks/student", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 舌诊考试：学生试卷详情页 （查看答题情况）
 * @param vCom Vue组件
 */
const GetExamAnswerDetail$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/edu/szks/reply", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 舌诊考试：考试记录列表页
 * @param vCom Vue组件
 */
const GetExamResultList$ = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/edu/szks/replys", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch(() => {
            reject();
        });
    });
};

export {
    GetShezhenjiaocai$, GetDianxingshetu$,
    GetShixunFenlei$, GetShixunTimu$, SaveShixinQuestionResult$, GetShixunReport$, GetUserInfo$,
    GetMoniTimu$, PostMoniSave$, CheckMoniResult$,
    GetExams$, FinishExam$, GetStudentInfo$, GetExamAnswerDetail$, GetExamResultList$
};

